module.exports = __webpack_public_path__ + "img/rule3.28e3234c.png";